import { render, staticRenderFns } from "./AddConfigModal.vue?vue&type=template&id=484be658&"
import script from "./AddConfigModal.vue?vue&type=script&lang=js&"
export * from "./AddConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports